<template>
    <div >
      
        <div v-if="storeInfo.storeTypeCd == '800900000000'">
            <index-dev></index-dev>
        </div>
        <div v-if="storeInfo.storeTypeCd == '800900000001'">
            <index-admin></index-admin>
        </div>
        <div v-if="storeInfo.storeTypeCd == '800900000003'">
            <index-property></index-property>
        </div>
    </div>
  </template>
  
  <script>
  import {getStoreInfo} from "@/api/user/indexApi"
  import {deepCopy} from "@/utils/vc"
  import indexDev from "@/components/index/index-dev.vue"
  import indexAdmin from "@/components/index/index-admin.vue"
  import indexProperty from '@/components/index/index-property.vue'
  
  export default {
    name: 'index',
    components: {
        indexDev,
        indexAdmin,
        indexProperty
    },
    data() {
      return {
         storeInfo:{
            storeTypeCd:'',
            storeId:''
         }
      }
    },
    created() {
        this._loadStoreInfo()
    },
    methods: {
      async _loadStoreInfo(){
        this.loading = true
          try {
            const res = await getStoreInfo()
            // 如果 API 返回空数据，从 localStorage 获取（登录时保存的）
            if (!res || !res.storeTypeCd) {
              const localStore = JSON.parse(localStorage.getItem('storeInfo') || '{}')
              if (localStore.storeTypeCd) {
                deepCopy(localStore, this.storeInfo)
              }
            } else {
              deepCopy(res, this.storeInfo)
              // 同时保存到 localStorage
              localStorage.setItem('storeInfo', JSON.stringify(res))
            }
          } catch (error) {
            console.error('加载门店信息失败：', error)
            // 失败时也从 localStorage 获取
            const localStore = JSON.parse(localStorage.getItem('storeInfo') || '{}')
            if (localStore.storeTypeCd) {
              deepCopy(localStore, this.storeInfo)
            }
          } finally {
            this.loading = false
          }
        
      }
    }
  }
  </script>
  
  <style scoped>
  </style> 